{
  "status": {
    "pending": "Menunggu",
    "preliminary": "Sementara",
    "final": "Final",
    "corrected": "Dikoreksi",
    "amended": "Dilengkapi",
    "addended": "Dengan Adendum",
    "enteredInError": "Salah Entri",
    "unknown": "Tidak Diketahui"
  },
  "review": {
    "title": "Tinjauan Hasil",
    "printLabel": "Cetak Hasil",
    "summary": {
      "count_one": "{{count}} hasil",
      "count_other": "{{count}} hasil",
      "criticalUnacknowledged": "{{count}} nilai kritis belum dikonfirmasi"
    },
    "view": {
      "timeline": "Linimasa",
      "flowsheet": "Lembar Alur"
    },
    "filter": {
      "date": "Tanggal",
      "type": "Jenis",
      "status": "Status",
      "statusAll": "Semua"
    },
    "dateRange": {
      "h24": "24 jam terakhir",
      "h48": "48 jam terakhir",
      "d7": "7 hari terakhir",
      "d30": "30 hari terakhir",
      "all": "Semua"
    },
    "resultType": {
      "all": "Semua",
      "lab": "Laboratorium",
      "imaging": "Pencitraan",
      "pathology": "Patologi",
      "cardiology": "Kardiologi",
      "microbiology": "Mikrobiologi"
    },
    "criticalOnlyToggle": "Hanya Nilai Kritis",
    "criticalBadge": "KRITIS",
    "actions": {
      "acknowledgeCritical": "Konfirmasi Kritis",
      "acknowledgeAllCritical": "Akui semua kritis ({{count}})"
    },
    "detail": {
      "resultNumber": "Nomor Hasil",
      "performingProviderId": "ID Pelaksana",
      "verifiedByProviderId": "ID Verifikator",
      "verifiedAt": "Diverifikasi pada",
      "specimenCollected": "Spesimen Diambil",
      "clinicalSignificance": "Signifikansi Klinis",
      "recommendations": "Rekomendasi",
      "report": "Laporan",
      "addendum": "Adendum",
      "criticalAcknowledged": "Nilai Kritis Dikonfirmasi",
      "providerHash": "Dokter #{{id}}",
      "acknowledgedAt": " pukul {{when}}",
      "specimenType": "Jenis Spesimen",
      "grossDescription": "Deskripsi Makroskopik",
      "microscopicDescription": "Deskripsi Mikroskopik",
      "accessionNumber": "Nomor Aksesi",
      "bodyRegion": "Regio Tubuh",
      "studyInstanceUid": "Study Instance UID",
      "cardiologyMeasurements": "Pengukuran",
      "heartRate": "HR",
      "prInterval": "PR",
      "qrsDuration": "QRS",
      "qtInterval": "QT",
      "qtcInterval": "QTc",
      "ejectionFraction": "EF"
    },
    "loading": "Memuat hasil…",
    "loadError": "Gagal memuat hasil. Silakan coba lagi.",
    "empty": "Tidak ada hasil yang sesuai dengan filter.",
    "toast": {
      "acknowledgeSuccess": "Nilai kritis dikonfirmasi",
      "acknowledgeError": "Gagal mengonfirmasi hasil"
    },
    "susceptibility": {
      "title": "Organisme dan Kepekaan",
      "antibiotic": "Antibiotik",
      "interpretation": "Interpretasi",
      "mic": "MIC",
      "unnamedOrganism": "Organisme tanpa nama",
      "noPanel": "Tidak ada hasil kepekaan yang dilaporkan untuk organisme ini."
    },
    "components": {
      "value": "Nilai",
      "referenceRange": "Rentang Rujukan"
    }
  },
  "pending": {
    "title": "Hasil Tertunda",
    "countBadge_one": "{{count}} tertunda",
    "countBadge_other": "{{count}} tertunda",
    "autoRefresh": "Penyegaran otomatis {{seconds}}d",
    "updated": "Diperbarui {{when}}",
    "searchPlaceholder": "Cari berdasarkan nama pasien, MRN, atau order…",
    "filtersButton": "Filter",
    "fields": {
      "orderType": "Jenis Order",
      "allTypes": "Semua Jenis",
      "priority": "Prioritas",
      "allPriorities": "Semua Prioritas",
      "dateFrom": "Dari Tanggal",
      "dateTo": "Sampai Tanggal"
    },
    "orderType": {
      "lab": "Laboratorium",
      "imaging": "Pencitraan",
      "procedure": "Tindakan",
      "consultation": "Konsultasi",
      "laboratory": "Laboratorium",
      "radiology": "Radiologi",
      "surgery": "Bedah",
      "therapy": "Terapi",
      "medication": "Obat",
      "admission": "Admisi"
    },
    "aria": {
      "dateFrom": "Hasil tertunda dari tanggal",
      "dateTo": "Hasil tertunda sampai tanggal"
    },
    "columns": {
      "patient": "Pasien",
      "mrn": "MRN",
      "order": "Order",
      "type": "Jenis",
      "orderedBy": "Diorder oleh",
      "ordered": "Waktu Order",
      "expected": "Diharapkan",
      "priority": "Prioritas"
    },
    "loading": "Memuat hasil tertunda…",
    "loadError": "Gagal memuat hasil tertunda",
    "retry": "Coba lagi",
    "empty": "Tidak ada hasil tertunda.",
    "awaitingResult": "Menunggu hasil",
    "specimenReceived": "Spesimen diterima",
    "inLab": "Di laboratorium",
    "cancelledByLab": "Dibatalkan oleh laboratorium",
    "overdue": "Lewat waktu",
    "expectedBy": "Diharapkan sebelum {{date}}"
  },
  "critical": {
    "title": "Hasil Kritis",
    "autoRefresh": "Penyegaran otomatis {{seconds}}d",
    "updated": "Diperbarui {{when}}",
    "unacknowledgedHeading_one": "{{count}} Nilai Kritis Belum Dikonfirmasi",
    "unacknowledgedHeading_other": "{{count}} Nilai Kritis Belum Dikonfirmasi",
    "escalationBanner": "Hasil ini memerlukan konfirmasi dokter segera.",
    "acknowledgeWithinMinutes": "Konfirmasi dalam {{minutes}} menit",
    "routeBackToProvider": "Kembalikan ke dokter pemberi order",
    "attendingSignoff": "Memerlukan tanda tangan dokter penanggung jawab",
    "searchPlaceholder": "Cari berdasarkan pasien atau nama tes…",
    "showAcknowledgedToggle": "Tampilkan yang dikonfirmasi",
    "escalationTime": "T+{{minutes}}mnt",
    "criticalFallback": "KRITIS",
    "loading": "Memuat hasil kritis…",
    "loadError": "Gagal memuat hasil kritis",
    "empty": "Tidak ada hasil kritis yang menunggu konfirmasi.",
    "detailToggleLabel": "Tampilkan detail hasil",
    "openFullChart": "Buka rekam medis lengkap",
    "columns": {
      "patient": "Pasien",
      "mrn": "MRN",
      "test": "Tes",
      "value": "Nilai",
      "impression": "Kesan",
      "resultTime": "Waktu Hasil",
      "escalation": "Eskalasi",
      "acknowledged": "Dikonfirmasi",
      "actions": "Tindakan"
    },
    "actions": {
      "acknowledge": "Konfirmasi"
    },
    "toast": {
      "acknowledgeSuccess": "Nilai kritis dikonfirmasi",
      "acknowledgeError": "Gagal mengonfirmasi hasil"
    },
    "refreshFailed": "Tidak dapat memuat ulang — menampilkan hasil kritis per {{when}}.",
    "incomplete": "Menampilkan {{shown}} dari {{total}} hasil kritis. Daftar ini tidak lengkap."
  },
  "acknowledged": {
    "pending": "Menunggu konfirmasi",
    "acknowledged": "Dikonfirmasi",
    "escalated": "Dieskalasi",
    "expired": "Jendela konfirmasi habis"
  },
  "flowsheet": {
    "analyte": "Analit",
    "empty": "Tidak ada analit laboratorium untuk ditampilkan",
    "emptyHint": "Laporan pencitraan, patologi, dan mikrobiologi muncul di tampilan lini masa.",
    "trend": {
      "toggle": "Tren {{analyte}}",
      "referenceRange": "Rujukan {{range}}",
      "nonNumericOmitted_one": "{{count}} hasil teks tidak digambarkan",
      "nonNumericOmitted_other": "{{count}} hasil teks tidak digambarkan"
    }
  }
}
